<template>
  <div class="after-sale">
    <div class="after-sale-top">
      <!-- tab切换 -->
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
      
      <!-- 统计信息 -->
      <div class="search-container">
        <div class="statistics">
          <div
            v-for="(item,index) in statisticsList"
            :key="index"
            class="item-statistics"
          >
            <div class="item-statistics-content">
              <div class="statistics-info">
                <div class="sub-title">
                  <span>{{item.title}}</span>
                  <el-button v-if="item.title === '未揽收订单数（单）'" @click="openUncollectedOrderNums" type="text" class="btn-text">详情</el-button>
                </div>
                <p v-if="!item.isFlag" class="sub-content">{{item.content}}</p>
                <div v-else class="express-container">
                  <p v-if="item.list.length === 0">—</p>
                  <div class="express-main">
                    <div class="express-main-left">
                      <div 
                        class="black-container"
                        :class="{'black-container-ative':(jIdx+1) == item.statisticsCurrentPage}"
                        v-for="(j, jIdx) in item.list" 
                        :key="jIdx"
                      >
                        <div
                          class="express-content" 
                          v-for="(v, idx) in j" 
                          :key="idx"
                        >
                          <span class="express-content-name">{{ v.expressName }}</span>
                          <span class="express-content-num">{{ v.orderNum }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="paging-container" v-if="item.list.length > 1">
                      <i @click="proPage(item)" class="el-icon-caret-left"></i>
                      <span class="paging-num">{{ item.statisticsCurrentPage }}/{{ item.list.length }}</span>
                      <i @click="nextPage(item, item.list.length)" class="el-icon-caret-right"></i>
                    </div>
                  </div>
                </div>
              </div>
              <img class="statistics-img" :src="item.img" alt>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 揽收数据 -->
    <div class="after-sale-container">
      <!-- 揽收数据 -->
      <div class="search">
        <div class="search-left">
          <span class="search-left-title">仓库名称：</span>
          <el-select
            v-model="warehouseId"
            clearable
            placeholder="请选择仓库"
            @change="changeWarehouse"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <span class="search-left-title">日期：</span>
          <el-date-picker
            class="marginRight"
            v-model="date"
            type="date"
            value-format="yyyy-MM-dd"
            clearable
            placeholder="选择日期">
          </el-date-picker>
          <el-button icon="el-icon-search" class="btn-blue" @click="searchData">搜索</el-button>
          <el-button icon="el-icon-refresh" class="btn-gray" @click="reset">重置</el-button>
        </div>
      </div>
      
      <!-- 揽收数据列表 -->
      <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :width="item.width"
          :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
        >
          <template slot-scope="scope">
            <p v-if="item.prop == 'name' || item.prop == 'createTime' || item.prop == 'finishOrderNums'">{{ scope.row[item.prop]}}</p>
            <div v-else class="express-info-container">
              <p v-if="!scope.row[item.prop]">—</p>
              <div v-else class="express-info">
                <div class="details-nums">
                  <span>{{scope.row[item.prop].totalValue}}</span>
                  <el-button v-if="item.prop === 'twoDaysWithin'" @click="openTwoDaysWithinCollectedOrderNums(item.id)" type="text" class="btn-text">详情</el-button>
                  <el-button v-if="item.prop === 'twoDaysAway'" @click="openTwoDaysAwayCollectedOrderNums(item.id)" type="text" class="btn-text">详情</el-button>
                </div>
                <div class="express-info-content">
                  <div class="details-expenses" v-for="(v, idx) in scope.row[item.prop].carrierCollectInfoList" :key="idx">
                    <p class="details-expenses-name">{{v.carrierKey}}</p>
                    <p class="details-expenses-num">{{v.carrierValue}}</p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 未揽收订单数 -->
    <el-drawer
      title="未揽收订单数"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleCloseDrawer">
      <div class="drawer-content">
        <!-- 未揽收订单数搜索 -->
        <div class="search">
          <div class="search-left">
            <span class="search-left-title">项目名称：</span>
            <el-select
              v-model="projectName"
              filterable
              clearable
              placeholder="请选择项目名称"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <span class="search-left-title">承运商：</span>
            <el-select
              v-model="expressId"
              filterable
              clearable
              placeholder="请选择承运商"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchUncollectedOrderNumsData">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetUncollected">重置</el-button>
          </div>
          <div class="search-right" @click="downLoadExcel">
            <span class="search-right-img"></span>
            <span>导出</span>
          </div>
        </div>

        <!-- 未揽收订单数列表 -->
        <div class="table">
          <el-table :data="uncollectedOrderNumsTableList" style="width: 100%;">
            <el-table-column
              v-for="(item, index) in uncollectedOrderNumsTableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
            ></el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @queryChange="queryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
      </div>
    </el-drawer>

    <!-- 揽收单量 -->
    <el-drawer
      :title="drawerTitle"
      :wrapperClosable="false"
      :visible.sync="drawerCollect"
      :before-close="closeCollectedOrderDialog">
      <div class="drawer-content">
        <!-- 揽收单量搜索 -->
        <div class="search">
          <div class="search-left">
            <span class="search-left-title">承运商：</span>
            <el-select
              v-model="expressType"
              filterable
              clearable
              placeholder="请选择承运商"
            >
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
            <el-button icon="el-icon-search" class="btn-blue" @click="searchCollectedOrderNumsData">搜索</el-button>
          </div>
        </div>

        <!-- 揽收单量列表 -->
        <div class="table">
          <el-table :data="collectedOrderNumsTableList" style="width: 100%;">
            <el-table-column
              v-for="(item, index) in collectedOrderNumsTableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.label"
              show-overflow-tooltip
              :min-width="item.width"
            ></el-table-column>
          </el-table>
          <div class="pagination">
            <pagination-tpl
              :total="collectedTotal"
              :currentPage="collectedTotalCurrentPage"
              :pageSize="collectedTotalPageSize"
              @queryChange="collectedQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </div>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="closeCollectedOrderDialog">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { formatTimeToDate, formaTimeToMinute, commafy, downLoadFileByBlob } from "common/js/util";
import Expenses from "models/expenses";
const expenses = new Expenses();
import AfterSale from "models/after-sale";
import PaginationTpl from "components/base/PaginationTpl";
import projectMixins from "@/common/mixins/project.js"
import expressMixins from "@/common/mixins/express.js"
export default {
  mixins: [projectMixins, expressMixins],
  components: {
    PaginationTpl,
  },

  data() {
    return {
      selectedTab: '揽收数据',
      menuList: [
        {name: '发货数据', url: '/home/production-data/shipment-data'},
        {name: '揽收数据', url: '/home/production-data/after-sale'}
      ],
      date: formatTimeToDate(new Date().getTime() - 60*60*24*1000),
      warehouseId: '',
      warehouseList: [],
      // 统计信息集合
      statisticsList: [
        {isFlag: 0, title: '揽收订单数（单）', content: 0, img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
        {isFlag: 0, title: '完成订单数（单）', content: 0, img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
        {isFlag: 0, title: '未揽收订单数（单）', content: 0, img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
        {statisticsCurrentPage: 1, list: [],isFlag: 1, title: '24小时内揽收', content: 0, img: require('../../../../../assets/images/production-data/24hours.png')},
        {statisticsCurrentPage: 1, list: [],isFlag: 1, title: '24-48小时内揽收', content: 0, img: require('../../../../../assets/images/production-data/36hours.png')},
        {statisticsCurrentPage: 1, list: [],isFlag: 1, title: '48小时以上揽收', content: 0, img: require('../../../../../assets/images/production-data/48hours.png')},
      ],
      // 揽收列表
      tableData: [],
      tableTitleList: [
        {label: '项目名称', prop: 'name', width: '', alignment:'left'},
        {label: '截单时间', prop: 'createTime', width: '90', alignment:'left'},
        {label: '完成订单数', prop: 'finishOrderNums', width: '', alignment:'right'},
        {label: '揽收订单数', prop: 'collectOrderNum', width: '', alignment:'right'},
        {label: '揽收率', prop: 'yield', width: '', alignment:'right'},
        {label: '0-24H揽收单量', prop: 'oneDaysWithin', width: '', alignment:'right'},
        {label: '24-48H揽收单量', prop: 'twoDaysWithin', width: '', alignment:'right'},
        {label: '48H以上揽收单量', prop: 'twoDaysAway', width: '', alignment:'right'},
      ],

      drawer: false,
      projectName: '',
      total: 0,
      currentPage: 1,
      pageSize: 20,
      // 未揽收订单数列表
      uncollectedOrderNumsTableList: [],
      uncollectedOrderNumsTableTitleList: [
        {label: '项目名称', prop: 'projectName', width: ''},
        {label: '快递类型', prop: 'expressTypeName', width: ''},
        {label: '订单号', prop: 'orderCode', width: ''},
        {label: '运单号', prop: 'expenseCode', width: ''},
      ],

      drawerTitle: '24H-48H揽收单量',
      drawerCollect: false,
      /* 2:24H-48H揽收单量; 3:48H以上揽收单量  */
      type: 2,
      expressId: '',
      expressType: '',
      collectedProjectId: '',
      collectedTotal: 0,
      collectedTotalCurrentPage: 1,
      collectedTotalPageSize: 10,
      // 揽收单量列表
      collectedOrderNumsTableList: [],
      collectedOrderNumsTableTitleList: [
        {label: '订单号', prop: 'orderCode', width: ''},
        {label: '运单号', prop: 'expenseCode', width: ''},
        {label: '付款时间', prop: 'paymentTime', width: '150'},
        {label: '接单时间', prop: 'orderTakingTime', width: '150'},
        {label: '完成时间', prop: 'finishTime', width: '150'},
        {label: '揽收时间', prop: 'collectedTime', width: '150'},
      ],
    }
  },

  activated() {
    this.selectedTab = '揽收数据'
  },

  async created() {
    await this.getWarehouse()
    this.initAfterSaleStatisticsList()
    this.initAfterSaleList()
    this.initExpressList()
  },

  methods: {
    /**
     * @desc 获取仓库数据
     */
    async getWarehouse() {
      let res = await expenses.getWarehouseData()
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
          this.warehouseId = arr.length > 0 ? arr[0].id : '';
          this.changeWarehouse(this.warehouseId)
        }
    },
    
    /**
     * @desc 获取揽收数据列表
     */
    initAfterSaleList() {
      let warehouseId = this.warehouseId
      let date = this.date
      let data = {
        warehouseId,
        date
      }
      AfterSale.getAfterSaleList(data).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.projectId
            obj.name = i.projectName
            obj.createTime = i.finalOrderTime
            obj.finishOrderNums = commafy(i.receiveOutboundOrderNum)
            obj.collectOrderNum = this.handelAfterNum(i.collectOrderInfo)
            obj.yield = i.collectRateInfo
            if (i.collectRateInfo) obj.yield.totalValue = commafy(i.collectRateInfo.totalValue)
            obj.oneDaysWithin = this.handelAfterNum(i.collectOrderInfoOfOneDay)
            obj.twoDaysWithin = this.handelAfterNum(i.collectOrderInfoOfBetweenOneAndTwoDay)
            obj.twoDaysAway = this.handelAfterNum(i.collectOrderInfoOfMoreThanTwoDay)
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /**
     * @desc 统计信息
     */
    initAfterSaleStatisticsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let data = {
        date,
        warehouseId
      }
      AfterSale.getAfterSaleStatisticsList(data).then(res => {
        if (res.success) {
          let { collectOrderNum, finishOrderNum, notCollectOrderNum, lessThan24HoursNum,
          between24And48HoursNum, moreThan48HoursNum, lessThan24HoursExpressCollectNum,
          between24And48HoursExpressCollectNum, moreThan48HoursExpressCollectNum } = res.result
          let lessThan24HoursExpressCollectNumList = this.handelNum(lessThan24HoursExpressCollectNum)
          let between24And48HoursExpressCollectNumList = this.handelNum(between24And48HoursExpressCollectNum)
          let moreThan48HoursExpressCollectNumList = this.handelNum(moreThan48HoursExpressCollectNum)
          this.statisticsList = [
            {isFlag: 0, title: '揽收订单数（单）', content: commafy(collectOrderNum), img: require('../../../../../assets/images/shipment-data/total-order-num.png')},
            {isFlag: 0, title: '完成订单数（单）', content: commafy(finishOrderNum), img: require('../../../../../assets/images/shipment-data/finish-order-num.png')},
            {isFlag: 0, title: '未揽收订单数（单）', content: commafy(notCollectOrderNum), img: require('../../../../../assets/images/shipment-data/incomplete-order-num.png')},
            {statisticsCurrentPage: 1, list: lessThan24HoursExpressCollectNumList, isFlag: 1, title: '24小时内揽收', content: lessThan24HoursNum, img: require('../../../../../assets/images/production-data/24hours.png')},
            {statisticsCurrentPage: 1, list: between24And48HoursExpressCollectNumList, isFlag: 1, title: '24-48小时内揽收', content: between24And48HoursNum, img: require('../../../../../assets/images/production-data/36hours.png')},
            {statisticsCurrentPage: 1, list: moreThan48HoursExpressCollectNumList ,isFlag: 1, title: '48小时以上揽收', content: moreThan48HoursNum, img: require('../../../../../assets/images/production-data/48hours.png')},
          ]
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    /**
     * @desc 获取未揽收订单数列表
     */
    async initUncollectedOrderNumsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let projectId = this.projectName
      let expressType = this.expressId
      let data = {
        date,
        warehouseId,
        currentPage,
        projectId,
        expressType
      }
      let res = await AfterSale.getUncollectedOrderNumsList(data)
      if (res.success) {
        let arr = [];
        this.total = res.result.totalNum
        res.result.items.map((i) => {
          let obj = {};
          obj.id = i.id;
          obj.projectName = i.projectName;
          obj.orderCode = i.systemOrderNo;
          obj.expenseCode = i.expressNo;
          obj.expressTypeName = i.expressTypeName;
          arr.push(obj);
        });
        this.uncollectedOrderNumsTableList = arr;
      }
    },

    /**
     * @desc 揽收单量列表
     */
    async initCollectedOrderNumsList() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.collectedTotalCurrentPage
      let projectId = this.collectedProjectId
      let carrierId = this.expressType
      let collectPaymentDifferenceType = this.type
      let data = {
        date,
        warehouseId,
        currentPage,
        carrierId,
        projectId,
        collectPaymentDifferenceType
      }
      let res = await AfterSale.getcollectedOrderNumsList(data)
      if (res.success) {
        let arr = [];
        this.collectedTotal = res.result.totalNum
        res.result.items.map((i) => {
          let obj = {};
          obj.orderCode = i.systemOrderNo;
          obj.expenseCode = i.expressNo;
          obj.paymentTime = i.paymentTime == 0?'':formaTimeToMinute(i.paymentTime);
          obj.orderTakingTime = i.warehouseOrderTime == 0?'':formaTimeToMinute(i.warehouseOrderTime);
          obj.finishTime = i.outboundTime == 0?'':formaTimeToMinute(i.outboundTime);
          obj.collectedTime = i.collectTime == 0?'':formaTimeToMinute(i.collectTime);
          arr.push(obj);
        });
        this.collectedOrderNumsTableList = arr;
      }
    },

    changeWarehouse() {
      this.initProjectListByWarehouse(this.warehouseId)
    },

    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },

    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex}) {
      if (columnIndex > 1) {
        return 'right-align'
      }
    },

    nextPage(row, allPage) {
      if (row.statisticsCurrentPage < allPage) row.statisticsCurrentPage++
    },

    proPage(row) {
      if (row.statisticsCurrentPage > 1) row.statisticsCurrentPage--
    },
    
    spitArr(arr) {
      let newArr = [];
      /* 将一位数组分割成每4个一组 */
      for (let j = 0; j < arr.length; j += 4) {
        newArr.push(arr.slice(j, j + 4));
      }
      return newArr;
    },

    /**
     * @desc 统计订单数添加千分位
     */
    handelNum(list) {
      let arr = []
      list.map(i => {
        let obj = {}
        obj.expressName = i.expressName
        obj.orderNum = commafy(i.orderNum)
        arr.push(obj)
      })
      let newArr = this.spitArr(arr)
      return newArr
    },

    /**
     * @desc 售后列表添加千分位
     */
    handelAfterNum(obj) {
      if (obj) {
        let obj2 = {}
        obj2.totalValue = commafy(obj.totalValue)
        obj2.carrierCollectInfoList = []
        obj.carrierCollectInfoList.map(i => {
          let obj3 = {}
          obj3.carrierKey = i.carrierKey.substr(0,6)
          obj3.carrierKeyCopy = i.carrierKey
          obj3.carrierValue = commafy(i.carrierValue)
          obj2.carrierCollectInfoList.push(obj3)
        })
        return obj2
      } else {
        return obj
      }
    },
    
    reset() {
      this.date = "";
      this.warehouseId = "";
    },

    searchData() {
      if (!this.warehouseId) return this.$message.error('请选择仓库')
      if (!this.date) return this.$message.error('请选择日期')
      this.initAfterSaleStatisticsList()
      this.initAfterSaleList()
    },

    /**
     * @desc 开启未揽收订单抽屉
     */
    async openUncollectedOrderNums() {
      await this.initUncollectedOrderNumsList()
      this.drawer = true
    },

    handleCloseDrawer() {
      this.currentPage = 1;
      this.projectName = ''
      this.expressId = ''
      this.drawer = false
    },
    
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initUncollectedOrderNumsList();
    },

    searchUncollectedOrderNumsData() {
      this.currentPage = 1;
      this.initUncollectedOrderNumsList()
    },

    resetUncollected() {
      this.projectName = ''
      this.expressId = ''
    },

    /**
     * @desc 导出未揽收订单数
     */
    downLoadExcel() {
      let date = this.date
      let warehouseId = this.warehouseId
      let currentPage = this.currentPage
      let projectId = this.projectName
      let expressType = this.expressId
      let data = {
        date,
        warehouseId,
        currentPage,
        projectId,
        expressType
      }
      AfterSale.getExportUncollectedOrderNumsExcel(data).then((res) => {
        downLoadFileByBlob(res)
      });
    },

    /**
     * @desc 开启24H-48H揽收单量抽屉
     */
    async openTwoDaysWithinCollectedOrderNums(id) {
      this.type = 2
      this.collectedProjectId = id
      this.drawerTitle = '24H-48H揽收单量'
      await this.initCollectedOrderNumsList()
      this.drawerCollect = true
    },

    /**
     * @desc 开启48H以上揽收单量抽屉
     */
    async openTwoDaysAwayCollectedOrderNums(id) {
      this.type = 3
      this.collectedProjectId = id
      this.drawerTitle = '48H以上揽收单量'
      await this.initCollectedOrderNumsList()
      this.drawerCollect = true
    },

    collectedQueryChange(data) {
      this.collectedTotalCurrentPage = data.currentPage;
      this.initCollectedOrderNumsList();
    },

    closeCollectedOrderDialog() {
      this.collectedTotalCurrentPage = 1;
      this.type = 1
      this.drawerTitle = '24H-48H揽收单量'
      this.expressType = ''
      this.drawerCollect = false
    },

    searchCollectedOrderNumsData() {
      this.collectedTotalCurrentPage = 1;
      this.initCollectedOrderNumsList()
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/quality/after-sale.scss';
</style>
